import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { AfterViewInit, Component, HostListener, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Observable, Subject, filter, takeUntil } from 'rxjs';
import { TokenService } from './services/token.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AccountInfo, InteractionRequiredAuthError, InteractionStatus } from '@azure/msal-browser';
import { MatrisLoaderHandlerService } from './matrisneocommon/matris-loader-handler.service';
import { environment } from 'src/environments/environment';
import { ImpulsesService } from './services/impulses.service';
import { MatrisMenubar } from './matrisneocommon/matris-menubar/matris-menubar.component';
import { version } from 'src/version';
import { DOCUMENT } from '@angular/common';
import { UserService } from './services/user.service';
import { AlertService } from './services/alert.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
  baseUrl = environment.baseUrl
  token: any;
  mobileMenuOpen = false;
  loginDisplay = false
  containerClasses = "page-container"
  username: string = ''
  //companyName: string = ''
  showOrders: boolean = false;
  showAlert: boolean = false;
  private readonly _destroying$ = new Subject<void>();
  globalId: any;
  globalPurchaserCode : any;
  userid: any;
  domain = "";
  userOrg = "";
  name = "";
  @ViewChild(MatrisMenubar) menubar: MatrisMenubar

  constructor(private userService: UserService, @Inject(DOCUMENT) private document: Document, private alertService: AlertService,
  private impulsesService: ImpulsesService, private httpClient: HttpClient, private tokenService: TokenService,
  private router: Router, private authService: MsalService, private msalBroadcastService: MsalBroadcastService
  ) {
    //console.log("MyApp version " + version.number);
  }

  @HostListener('window:resize', [])
  getRoute() {

    if (this.router.url == "/") {
      if (window.screen.availWidth > 600) {
        return this.setBackGroundImageClass("background-image", window.screen.availWidth)
      } else {
        return this.setBackGroundImageClass("background-image-mobile", window.screen.availWidth)
      }

    } else {
      return this.setBackGroundImageClass("", window.screen.availWidth)
    }
  }

  setBackGroundImageClass(className: string, width: number) {
    if (width > 600) {
      this.containerClasses = ""
      this.containerClasses = "page-container " + className
    } else {
      this.containerClasses = ""
      this.containerClasses = "page-container " + className
    }
    return this.containerClasses;
  }

  setFavicon() {
    const favicon: HTMLLinkElement | null = this.document.getElementById('appFavicon') as HTMLLinkElement;
    if (favicon) {
      favicon.href = environment.favicon;
    }
  }

  ngOnInit(): void {

    // this.tokenService.getToken().subscribe((data: any) => {
    //   localStorage.setItem('token', data["access_token"]);
    //   this.token = data["access_token"];
    // });

    this.setFavicon();

    this.router.events.subscribe((evt) => {
      if (evt instanceof NavigationEnd) {
        this.mobileMenuOpen = false;
      }
    });

    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status: InteractionStatus) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        this.setLoginDisplay();
      });
    
    this.alertService.profileSaved$
      .pipe(takeUntil(this._destroying$))
      .subscribe(() => {
        this.isShowAlert();
      });

  }

  ngAfterViewInit() {
    // this.toastService.setToast(this.toast);
    // Required for tab state service
  }

  isShowAlert(){
    if (!this.globalPurchaserCode) {
    this.showAlert = false;
    return;
  }

  this.userService
    .checkPurchaserMaterialStatus(this.globalPurchaserCode)
    .subscribe({
      next: (response: any) => {
        this.showAlert = response?.ShowAlert === true;
        console.log("Alert:",this.showAlert);
        
      },
      error: () => {
        this.showAlert = false;
      }
    });
  }

  getUserId(username: any) {
    return this.httpClient
      .get(this.baseUrl + `/get_userid_by_emailaddress?emailAddress=${username}`)
  }


  setLoginDisplay() {
    this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    var currentAccount: any = this.authService.instance.getAllAccounts().length > 0 ? this.authService.instance.getAllAccounts()[0] : null;
    if (currentAccount == null) {
      return;
    }
    this.userService.setUsername(currentAccount.name);
    this.authService.acquireTokenSilent({
      account: currentAccount,
      scopes: environment.scopes,
      forceRefresh: false
    }).subscribe({

      next: (value: any) => {
        this.menubar.setMenubarItems();
        this.username = currentAccount['username'];
        if (this.username.toLowerCase().includes('@navistar.com')) {
          this.username = this.username.replace(/@navistar\.com/i, '@international.com');
        }
        if (this.username != '') {
          this.saveUserProfile(currentAccount.name);
        }
        //Finding userOrg
        this.getUserOrg(currentAccount.idTokenClaims.ctry);
      },
      error: (err) => {
        this.authService.acquireTokenRedirect({ account: currentAccount, scopes: environment.scopes }).subscribe({
          next:(value:any) => {
            this.menubar.setMenubarItems();
          this.username = currentAccount['username'];
          if (this.username != '') {
            this.saveUserProfile(currentAccount.name);
          }
          this.getUserOrg(currentAccount.idTokenClaims.ctry);
        }
      });
    },
  });
}

private saveUserProfile(displayName: string) {
  const email = this.username;

  this.getUserId(email).subscribe({
    next: (data: any) => {
      const row = Array.isArray(data) ? data[0] : null;
      if (!row?.userid) {
        console.error('[Profile] No user row returned for', email, data);
      }
      this.globalId = row?.userid ?? '';
      this.globalPurchaserCode = row?.purchaserCode ?? '';

      this.isShowAlert();

      this.writeProfile(email, {
        username: email,
        name: displayName || email,
        globalId: this.globalId,
        globalPurchaserCode: this.globalPurchaserCode
      });
    },
    error: (err) => {
      console.error('[Profile] get_userid_by_emailaddress failed', err);
      // Keep what MSAL already told us so name/email are never lost
      this.writeProfile(email, {
        username: email,
        name: displayName || email
      });
    }
  });
}

private writeProfile(email: string, partial: { [key: string]: any }) {
  let settings: any = {};
  try {
    settings = JSON.parse(localStorage.getItem('matris_user_settings') || '{}');
  } catch {
    settings = {};
  }

  let existing = settings.userProfile || {};
  if (existing.username && email && existing.username.toLowerCase() !== email.toLowerCase()) {
    existing = {};
  }

  const next: any = { ...existing };
  Object.keys(partial).forEach(k => {
    if (partial[k] !== '' && partial[k] !== null && partial[k] !== undefined) {
      next[k] = partial[k];
    }
  });
  if (this.userOrg) {
    next.userOrg = this.userOrg;
  }

  settings.userProfile = next;
  localStorage.setItem('matris_user_settings', JSON.stringify(settings));
}

getUserOrg(ctry: string) {
  const emailParts = this.username.split('@');
  this.domain = emailParts[1];
  if (this.domain == 'scania.com') {
    this.userOrg = ctry == 'CN' ? 'China' : 'Scania';
  } else if (this.domain == 'scania.com.cn') {
    this.userOrg = 'China';
  } else if (this.domain == 'man.eu') {
    this.userOrg = 'MAN';
  } else if (this.domain == 'navistar.com' || this.domain == 'international.com') {
    this.userOrg = 'Navistar';
  }
  this.writeProfile(this.username, { userOrg: this.userOrg });
}
  // getCompanyName(value: string) {
  //   value = value.replace(".com", "")
  //   switch (value) {
  //     case "scania":
  //       return "Scania"
  //       break;
  //     case "man":
  //       return "MAN"
  //       break;
  //     case "vw":
  //       return "VW"
  //       break;
  //     default:
  //       return "Scania"
  //       break;
  //   }
  // }

}

